<template>
    <progress-bar
        class="checkout-progress-bar"
        style="display:flex; justify-content:center"
    >
        <slot></slot>
    </progress-bar>
</template>

<script>
import { CProgressBar } from '../Styles/Template/styled';

export default {
    name: "ProgressBar",
    components: {
        'progress-bar': CProgressBar
    }
};
</script>
